import { useAppTheme } from '@droplet-tech-code/core-elements/module/theme';
import { VStack } from '@droplet-tech-code/core-elements/module/ui/Stack';
import {
  isNativeMobile,
  isWeb,
} from '@droplet-tech-code/core-elements/module/utils/utils.helper';
import { BookingListItemResponse } from '@naus-code/naus-admin-types';
import { useCallback, useRef } from 'react';

import { useItemSeparatorComponent } from '~/components/FlatList/FlatList.Common';

import { useAppNavigation } from '~/hooks/nav.hook';
import { translate } from '~/utils/translation.utils';

import { FlatList } from '~/components/FlatList/FlatList';
import { bookingApi, BookingSearchItemResponse } from '../Bookings.api';
import { BookingListItemComponent } from '../Booking.ListItem';
import { BookingsListHeaderFullName } from './BookingsByName.ListHeader';
import { LoadingIndicator } from '@droplet-tech-code/core-elements/module/ui/Loading';

export interface BookingListProps {
  onPress: (booking: BookingSearchItemResponse) => void;
  firstName: string;
  lastName: string;
}

export const BookingListNative = ({
  firstName,
  lastName,
}: {
  firstName: string;
  lastName: string;
}) => {
  const navigate = useAppNavigation();
  return (
    <BookingList
      firstName={firstName}
      lastName={lastName}
      onPress={(item) => {
        navigate.navigate('Booking-Item', {
          id: item.id,
        });
      }}
    />
  );
};

export const BookingList = (props: BookingListProps) => {
  const selectedRef = useRef('');
  const { spacing } = useAppTheme();

  const renderItem = useCallback(
    (booking: BookingListItemResponse) => {
      return <BookingListItemComponent key={booking.id} booking={booking} />;
    },
    [props.firstName, props.lastName],
  );

  const { data, isLoading } = bookingApi.useGetBookingListByNameQuery({
    firstName: props.firstName,
    lastName: props.lastName,
    vectorisedSearchRequest: { depth: 20 },
  });

  const ItemSeparatorComponent = useItemSeparatorComponent();

  const fullName = props.firstName + ' ' + props.lastName;

  return (
    <VStack flex={1}>
      <BookingsListHeaderFullName fullName={fullName} onPress={() => {}} />
      {isLoading ? (
        <LoadingIndicator />
      ) : (
        <FlatList
          key={fullName}
          data={data?.list || []}
          isLoading={isLoading}
          feedback={translate('bookings.emptyBookings')}
          showsVerticalScrollIndicator={isWeb}
          contentContainerStyle={[
            {
              paddingTop: spacing[2.5],
            },
            isNativeMobile && { paddingHorizontal: spacing[2] },
          ]}
          renderItem={renderItem}
          onPressItem={(v) => {
            selectedRef.current = v.id;
            props.onPress(v);
          }}
          ItemSeparatorComponent={ItemSeparatorComponent}
        />
      )}
    </VStack>
  );
};
